import { Component, Input, OnInit } from '@angular/core';
import { PermissionService } from '../../Service/Permission/permission.service';

@Component({
  selector: 'app-permission-wrapper',
  template: `
    <ng-container *ngIf="hasPermission">
      <ng-content></ng-content>
    </ng-container>
  `
})
export class PermissionWrapperComponent implements OnInit {
  @Input() permission = '';
  hasPermission = false;

  constructor(private permissionService: PermissionService) {}

  ngOnInit(): void {
    if (this.permission) {
      this.hasPermission = this.permissionService.hasPermission(this.permission);
    }
  }
}
